export enum FollowUpStudyCompletionItemStatusCode {
	NotifiedAwaitingResponse = "NOTIFIED_AWAITING_RESPONSE",
	ResponseReceived = "RESPONSE_RECEIVED",
	DeadlinePassedNoResponse = "DEADLINE_PASSED_NO_RESPONSE",
	DocumentNotObtainable = "DOCUMENT_NOT_OBTAINABLE",
}
